import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IList } from './list.interface';

@Component({
    selector: 'mlp-ng-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ListSharedComponent {
    @Input() list: Array<IList>;
    @Input() size: 'smaller';
}
